import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 999;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

interface IContainer {
  width?: number;
}

export const Container = styled.div<IContainer>`
  /* Layout Properties */

  width: ${({ width }) => width || 379}px;
  // display: flex;
  align-self: center;
  //align-items: center;
  justify-self: center;
  //justify-content: space-between;
  z-index: 10;
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 18px 24px 24px 24px;
  /* UI Properties */
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 9px 26px #0000003d;
  border-radius: 8px;
  opacity: 1;
  animation: show 0.2s;
  transform: scale(1);
  grid-template-columns: minmax(min-content, 500px) 1fr;
  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
`;

export const Cancel = styled.button`
  font-size: 14px;
  background: none;
  font-weight: 500;

  color: #474d66;

  background-color: #fff;
  /* borders/default-border */
  border: 1px solid #d8dae5;
  box-sizing: border-box;
  border-radius: 8px;
  white-space: nowrap;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0;
  height: 42px;
  padding: 10px 16px;
  margin-right: 8px;
`;

interface IDelete {
  disabled?: boolean;
}

export const Delete = styled.button<IDelete>`
  font-size: 14px;
  white-space: nowrap;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid ${beam.border.back};
  height: 42px;
  color: ${({ disabled }) => (disabled ? '#c1c4d6' : '#fff')};
  background-color: ${({ disabled }) => (disabled ? '#edeff4' : '#d14343')};
  border-radius: 8px;
  padding: 10px 16px;
  /* Inside Auto Layout */
  flex: none;
  order: 1;
  flex-grow: 0;
`;

export const Header = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #161a30;
`;

export const Text = styled.span`
  font-weight: 400;
  font-size: 14px;

  color: #474d66;

  &.label {
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 8px;
    margin-left: 2px;
  }

  &.note {
    font-size: 12px;
    font-weight: 400;
    color: #696f8c;
    margin-bottom: 28px;
    margin-top: 8px;
    margin-left: 2px;
  }
`;

export const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  margin-bottom: 28px;
`;

export const CloseButton = styled.button`
  display: flex;
  background-color: transparent;
  border: 0;
  padding-top: 6px;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const Bold = styled.strong`
  font-size: 14px;
  font-weight: 500;
  color: #474d66;
`;

export const RedBold = styled.strong`
  font-size: 14px;
  font-weight: 400;
  color: #d14343;
`;

interface IDivider {
  height?: string;
}

export const Divider = styled.div<IDivider>`
  height: ${({ height }) => height};
`;

export const Form = styled.form`
  width: 100%;
`;
